module.exports = "<div style=\"width:80%; min-width: 600px; margin:0 auto;\">\n    <mat-card>\n        <h3 class=\"text-center\">Enter Email to Proceed</h3>\n        <mat-form-field style=\"padding:0px; width:100%\">\n            <input matInput placeholder = \"Email\" matTooltip=\"Enter your email to proceed\"  matTooltipPosition=\"before\" name = \"UserId\" ngModel>\n            \n          </mat-form-field>\n       \n        \n    </mat-card>\n  </div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/demo/demo.component.html
// module id = ./src/app/demo/demo.component.html
// module chunks = main